module.exports = __webpack_public_path__ + "static/img/Aac4.25f783f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aac4.png
// module id = p3V2
// module chunks = 1